module.exports = {"TXTWCL_Just_so_you_know":{"id":"TXTWCL_Just_so_you_know","defaultMessage":"Jen abyste věděli","track":"Just so you know"}}